export const LANGUAGE_STORAGE_KEY = "language";
const DEFAULT_LANGUAGE = "en";
const SUPPORTED_LANGUAGES = ["ru", "en"];

// Определяем язык браузера/системы пользователя (navigator.languages в приоритете,
// т.к. учитывает весь список предпочитаемых языков, а не только основной)
function detectBrowserLanguage() {
  const browserLanguages =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || navigator.userLanguage];
  for (const lang of browserLanguages) {
    if (!lang) continue;
    const shortLang = lang.slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(shortLang)) {
      return shortLang;
    }
  }
  return DEFAULT_LANGUAGE;
}

export function getLanguage() {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored && SUPPORTED_LANGUAGES.includes(stored)) {
    return stored;
  }
  // Первый визит: сохраняем определённый язык, чтобы дальше отдавать его стабильно
  const detected = detectBrowserLanguage();
  localStorage.setItem(LANGUAGE_STORAGE_KEY, detected);
  return detected;
}
